import { useQuery } from '@tanstack/react-query'
import { PlacesApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

/** 現場ツリー。旧スケジュールの編集と同じ API（現場グループと配下の現場のネスト） */
export const useQueryTaskSchedulePlaceGroups = () =>
  useQuery({
    queryKey: queryKeys.placeGroups,
    queryFn: () => baseClient.getApi(PlacesApi).getPlaceGroups(),
    gcTime: 0,
  })
